module.exports = __webpack_public_path__ + "img/refresh-icon.b839a68c.svg";